import Api from '@api/live'
import { Case } from '@components/LocalMerchant/LiveManage/ReportForm/LiveInfo/settings'
import { LIVE_MANAGE_PATH } from '@constant'
import { dGet } from '@core/utils'
import { getDateFormat, isToday } from '@hlj/hlj-utils'
import {
  getSessionMerchantInfo,
  isWeddingDressProperty
} from '@merchant-backend/util'
import { getMerchantInfo, isHotelMerchant } from '@util'
import dayjs from 'dayjs'
import { message, Modal } from 'hljd'
import getValue from 'lodash/get'
import toString from 'lodash/toString'
import { action, observable, runInAction } from 'mobx'
import { hashHistory } from 'react-router'
import investModal from '../InvestModal'
import LiveSpread from '../LiveSpread'
import {
  GiftOfAttention,
  GiftOfReservation,
  LivePoint,
  LiveTime,
  OtherActivity,
  Title,
  Type,
  Video,
  VideoCover
} from './LiveInfo/settings'

const merchantInfo = getMerchantInfo() //商家信息
const { property_id, property = {} } = merchantInfo //商家id
const name = property.name //商家name

export default class {
  @observable activity_components = this.getActivityComponents()

  @observable base_components = [Title, Type, LiveTime, VideoCover, Video]

  spread_components = [LiveSpread] //直播推广模块

  @observable image_path = '' // 封面图地址
  @observable vertical_image_path = '' // 封面图地址

  // 横图视频
  @observable
  videoInfo = {
    width: '',
    heigh: '',
    origin_path: '',
    persistent_id: ''
  }

  // 竖图视频
  @observable
  verticalVideoInfo = {
    width: '',
    height: '',
    vertical_origin_path: '',
    vertical_persistent_id: ''
  }
  @observable videoCover = '' // 视频封面

  @observable packageModalStatus = false // 选择套餐弹出层
  @observable caseModalStatus = false // 选择案例弹出
  @observable betterModalStatus = false // 优秀案例
  @observable betterCases = [] // 优秀案例
  @observable packageList = [] // 套餐列表
  @observable caseList = [] // 案例列表
  @observable watching_focus = [] // 直播看点
  @observable status = undefined // 审核状态
  @observable auditing_remark = undefined // 审核描述
  @observable is_live_recommend = false
  @observable live_type = ''
  @observable agreementVisible = false //协议弹框
  @observable isShowAgreement = false //是否在只读协议

  @observable
  tips = {
    appointment_content: '',
    other_gift_content: '',
    gift_of_attention: ''
  } // 礼包提示
  @observable useLessTime = [] // 不可用时间
  @observable poster = {} // poster

  getActivityComponents() {
    if (isHotelMerchant()) {
      return [LivePoint, GiftOfReservation, GiftOfAttention]
    }
    if (isWeddingDressProperty()) {
      return [LivePoint, GiftOfReservation, OtherActivity, GiftOfAttention]
    }
    return [Case, LivePoint, GiftOfReservation, OtherActivity, GiftOfAttention]
  }

  @action
  init = async (setValue, id) => {
    const { success, data = {} } = await Api.reportFormData({ id })
    if (!success) {
      return
    }
    // 获取套餐列表
    //this.getPackageList(0)
    // 获取案例列表
    this.getPackageList(1)
    // 获取礼包提示
    this.getGiftTips()
    // 获取不可用时间
    this.getUselessTime()
    // 获取商学院案例
    this.getBetterCase()

    if (!id) {
      return
    }

    const {
      title,
      start_time,
      image_path,
      vertical_image_path,
      video_path,
      vertical_video_path,
      //appointment_content,
      //other_gift_content,
      //docking_name,
      //docking_tel,
      status,
      preheat_list = [],
      //auditing_remark,
      merchant,
      from_type,
      live_type,
      agreement = true,
      new_type,
      pop_time,
      extension_banner,
      recommend_list,
      watching_focus
    } = data

    this.getSpreadInfo(id, start_time)

    const appointment_content = preheat_list.find(item => item.type == 1)
    const other_gift_content = preheat_list.find(item => item.type == 2)
    const gift_of_attention = preheat_list.find(item => item.type == 5)
    // 表单的赋值
    setValue({
      title, // 标题
      agreement,
      datePicker: start_time
        ? dayjs(getDateFormat(start_time, 'YYYY-MM-DD HH:mm'))
        : undefined, // 直播时间（日期）
      appointment_content: getValue(appointment_content, 'content.text', ''), // 预约礼包
      other_gift_content: getValue(other_gift_content, 'content.text', ''), // 其他活动
      gift_of_attention: getValue(gift_of_attention, 'content.text', ''), // 关注礼包
      fromType: +from_type,
      newType: +new_type,
      liveType: +live_type, //直播范围
      popTime: +pop_time ? 0 : 45, //推广时长
      extensionBanner: extension_banner //推广banner
      //docking_name, // 对接人姓名
      //docking_tel // 对接人手机号码
    })
    // 双向绑定赋值
    runInAction(() => {
      this.id = id
      this.image_path = image_path || '' // 直播封面
      this.vertical_image_path = vertical_image_path || '' // 直播封面
      this.verticalVideoInfo.vertical_origin_path = vertical_video_path || '' // 预热纵向视频
      this.videoInfo.origin_path = video_path || '' // 预热视频
      this.status = status
      //this.auditing_remark = auditing_remark
      this.live_type = +live_type
      this.from_type = +from_type
      this.watching_focus = watching_focus || []
      this.is_live_recommend = merchant
        ? merchant.is_live_recommend != 0
        : false

      const packageList =
        recommend_list && recommend_list.find(r => r.type == 4)
      const caseList = recommend_list && recommend_list.find(r => r.type == 7)
      // 套餐和案例
      this.packageList = packageList ? this.idsToString(packageList.entity) : []
      this.caseList = caseList ? this.idsToString(caseList.entity) : []
      this.start_time = start_time
    })
  }

  @action
  getBetterCase = async () => {
    const { data } = await Api.getBetterCase()
    this.betterCases = data || []
  }

  @action
  idsToString = list => {
    if (!list) return
    list.forEach(item => (item.id = toString(item.id)))
    return list
  }

  /**
   * 套餐和案例列表
   */
  @action
  getPackageList = async type => {
    this.loading = true

    const params = {
      page: 1,
      per_page: 200,
      is_sold_out: 0,
      commodity_type: type,
      status: 1
    }

    const {
      data: { list = [] }
    } = await Api.getPackageList(params)

    /* 匹配列表 */
    const getList = (checks, alls) => {
      if (!alls) return []
      return alls.map(item => {
        const check = checks.find(c => toString(c.id) === toString(item.id))
        return {
          ...item,
          id: toString(item.id),
          checked: !!check,
          activity_price:
            check && check.activity_price ? check.activity_price : null
        }
      })
    }

    // 套餐
    if (type == 0) {
      this.packageList = getList(this.packageList, list)
    } else {
      this.caseList = getList(this.caseList, list)
    }
  }

  /**
   * 礼包提示
   */
  getGiftTips = () => {
    const { property_id } = getSessionMerchantInfo()
    let tips = {}
    switch (+property_id) {
      // 婚纱摄影
      case 6:
        tips = {
          appointment_content:
            '例如：机票补贴2000元/套系5折/立减2000、送微电影/夜景/婚纱/对戒/登记照、加拍主题/套系升级/礼服免租，到店送扫地机器人/拉杆箱/瘦脸仪、千元礼包等',
          other_gift_content:
            '例如：抽奖礼（预约抽奖，抽中即送/下单送）；一等奖1名：婚纱照免单/iPhone X；二等奖2名：送口红/婚纱/秀禾/微电影/加1晚酒店；三等奖3名：照片墙/摆台；参与奖：千元礼包',
          gift_of_attention: '例如：关注免费定制方案'
        }
        break
      // 婚纱礼服
      case 12:
      case 9:
        tips = {
          appointment_content:
            '例如：免费试纱/试妆、免费送伴娘服、样衣特卖1折起、5件套仅1099、9.9元租婚纱、预约立减2000元',
          other_gift_content:
            '例如：抽奖礼（预约抽奖，抽中即送/下单送）；一等奖1名：婚纱礼服1件免单；二等奖2名：订单+1元送出门纱免租；三等奖3名：免租4套伴娘服/口红/婚鞋/晨袍',
          gift_of_attention: '例如：关注免费定制方案'
        }
        break
      // 婚礼策划
      case 2:
        tips = {
          appointment_content:
            '例如：免费婚礼策划方案/免费手绘方案/免费情侣头像logo/定制情侣对戒/1000元优惠券/线下婚礼秀门票',
          other_gift_content:
            '例如：抽奖礼（预约抽奖，抽中即送/下单送）；一等奖1名：免单/免租婚纱礼服；二等奖2名：送四大金刚/口红/对戒；三等奖3名：送伴手礼/陪嫁箱',
          gift_of_attention: '例如：关注免费定制方案'
        }
        break
      // 婚宴酒店
      case 13:
        tips = {
          appointment_content:
            '例如：预约礼为直播间预约到店用户，专享的礼包，如，预约酒水全部免费/菜品打8.8折等',
          other_gift_content: '',
          gift_of_attention: '例如：关注免费定制方案'
        }
        break
      default:
        tips = {
          appointment_content:
            '例如：送全新婚纱/口红/钻戒/项链/情侣对戒/登记照/甜品台/伴手礼/香水，立减1000元等',
          other_gift_content:
            '例如：抽奖礼（预约抽奖，抽中即送/下单送）；一等奖1名：免单/免租婚纱礼服；二等奖2名：口红/对戒；三等奖3名：送伴手礼/陪嫁箱',
          gift_of_attention: '例如：关注免费定制方案'
        }
        break
    }
    runInAction(() => {
      this.tips = tips
    })
  }
  /**
   * 获取不可用时间
   */
  @action
  getUselessTime = async () => {
    const { data = [] } = await Api.getUselessTime()
    runInAction(() => (this.useLessTime = data))
  }

  /**
   * 上传封面图
   */
  // 横图onUpload
  @action
  handleUploadVideoCover = (file, link, info) =>
    runInAction(() => {
      this.image_path = link
    })
  // 竖图onUpload
  @action
  changeVImage = (file, link, info) =>
    runInAction(() => {
      this.vertical_image_path = link
    })
  @action
  handleUploadWatching = (file, link, info) => {
    const { width, height } = info
    if (width < 1080) {
      message.warning('图片宽度需要大于1080px')
      return
    }
    ////暂时撤销高度：1920的限制
    // if (height > 1920) {
    //   message.warning('图片高度需要小于1920px')
    //   return
    // }
    if (this.watching_focus.length >= 10) {
      message.warning('最多可上传10张图片')
      return
    }

    this.watching_focus.push({
      type: 1,
      photo: {
        cover_path: link,
        width: width,
        height: height
      }
    })
  }

  /**
   * 裁剪封面图
   */
  // 横图onCliped
  @action
  handleClipedVideoCover = ({ width: limitWidth, height: limitHeight }) => ({
    clipUrl,
    pixel: { width, height }
  }) => {
    if (width < limitWidth || height < limitHeight) {
      return message.error(
        `图片宽度需不小于${limitWidth}px，图片高度需不小于${limitHeight}px`
      )
    }
    this.image_path = clipUrl
  }

  // 竖图onCliped
  @action
  ClipedVImage = ({ width: limitWidth, height: limitHeight }) => ({
    clipUrl,
    pixel: { width, height }
  }) => {
    if (width < limitWidth || height < limitHeight) {
      return message.error(
        `图片宽度需不小于${limitWidth}px，图片高度需不小于${limitHeight}px`
      )
    }
    this.vertical_image_path = clipUrl
  }
  @action
  handleDeleteWatching = (e, path) => {
    this.watching_focus = this.watching_focus.filter(
      item => item.photo.cover_path !== path
    )
  }
  /**
   * 删除封面图
   */
  @action
  handleDeleteVideoCover = () => runInAction(() => (this.image_path = ''))
  @action delVImage = () => runInAction(() => (this.vertical_image_path = ''))
  /**
   * 上传视频
   */
  @action
  handleUploadVideo = (file, link, { persistent_id, avinfo }, kind) => {
    // kind ==> horizontal：横向；longitudinal：纵向
    const { height, width, duration } = dGet(avinfo, 'video')
    if (+duration >= 16) {
      return message.warn('视频时间超过15S，请重新选择')
    }
    // 视频比例强校验
    /* if (kind === 'horizontal' && display_aspect_ratio !== '16:9') {
      return message.warn('横图视频宽高比建议为16：9，请重新选择')
    }
    if (kind === 'longitudinal' && display_aspect_ratio !== '2:3') {
      return message.warn('竖图视频宽高比建议为2：3，请重新选择')
    }*/
    runInAction(() => {
      if (kind === 'horizontal') {
        this.videoInfo = {
          width,
          height,
          origin_path: link,
          persistent_id
        }
      } else if (kind === 'longitudinal') {
        this.verticalVideoInfo = {
          width,
          height,
          vertical_origin_path: link,
          vertical_persistent_id: persistent_id
        }
      }
    })
  }

  /**
   * 删除视频
   */
  @action
  handleDeleteVideo = kind => {
    if (kind === 'horizontal') {
      this.videoInfo = {
        width: '',
        heigh: '',
        origin_path: '',
        persistent_id: ''
      }
    } else if (kind === 'longitudinal') {
      this.verticalVideoInfo = {
        width: '',
        height: '',
        vertical_origin_path: '',
        vertical_persistent_id: ''
      }
    }
  }

  /**
   * 选择套餐
   */
  showPackageModal = () => runInAction(() => (this.packageModalStatus = true))

  /**
   * 选择案例
   */
  showCaseModal = () => runInAction(() => (this.caseModalStatus = true))

  /**
   * 关闭套餐Modal
   */
  closePackageModal = () =>
    runInAction(() => {
      this.packageModalStatus = false
    })
  /**
   * 关闭套餐Modal
   */
  closeCaseModal = () =>
    runInAction(() => {
      this.caseModalStatus = false
    })
  /**
   * 保存选中的套餐
   */
  @action
  savePackage = packageList => {
    this.packageModalStatus = false
    this.packageList = packageList
  }

  @action
  saveCase = (list, tip) => {
    this.caseModalStatus = false
    this.caseList = list
  }

  /**
   * 删除选中的套餐
   */
  @action
  deleteRecommendItem = id =>
    runInAction(() => {
      this.packageModalStatus = false
      const packaged = this.packageList.find(el => el.id === id)
      packaged.checked = false
    })

  @action
  deleteCaseItem = id => {
    const item = this.caseList.find(c => c.id === id)
    item.checked = false
  }

  /**
   * 检测选中的时间
   */
  @action
  handleChackTime = (value, get, set) => {
    const selectedDay = get('datePicker')
    if (selectedDay) {
      const time = `${selectedDay.format(__FMT1__)} ${value}`
      if (isToday(selectedDay)) {
        if (!dayjs().isBefore(dayjs(time), 'seconds')) {
          message.warn('请选择未来时间')
        }
        set({
          timePicker: value
        })
      }
      this.getSpreadInfo(this.id, time)
    }
  }
  /**
   * 检测选择的日期
   */
  @action
  handleChackDate = (value, get, set) => {
    if (!value) {
      return
    }
    const time = `${value.format(__FMT2__)}`
    if (isToday(value)) {
      if (!dayjs().isBefore(dayjs(time), 'seconds')) {
        message.warn('请选择未来时间')
      }
      set({
        datePicker: value
      })
    }
    this.getSpreadInfo(this.id, time)
  }

  /**
   * 获取推广单价
   */
  @observable live_info = {}
  getSpreadInfo = async (id, start_time) => {
    const { success, data } = await Api.livePopInfo({ id, start_time })
    if (success) {
      this.live_info = data
    }
  }

  /**
   * 关闭开启优秀案例模态框
   */
  triggerBetterModal = () => {
    this.betterModalStatus = !this.betterModalStatus
    if (!this.betterModalStatus) hashHistory.push(LIVE_MANAGE_PATH)
  }

  /**
   * 优秀案例不再提示
   */
  neverMind = () => {
    Api.neverMindCase({ is_live_recommend: 0 })
    this.betterModalStatus = false
    hashHistory.push(LIVE_MANAGE_PATH)
  }

  /*
  * 展示协议具体内容
  * */
  @action
  showAgreementDetail = () => {
    setTimeout(() => {
      this.agreementVisible = !this.agreementVisible
      this.isShowAgreement = !this.isShowAgreement
    }, 0)
  }

  /*
  * 协议弹框-是否同意协议
  * */
  @action
  handleAgreement = (agreement, form) => {
    // 直接执行赋值操作
    this.agreementVisible = false
    if (agreement) {
      form.setFieldsValue({ agreement: agreement })
      // 手动提交
      const values = form.getFieldsValue()
      this.checkSubmit(values)
    }
  }

  /**
   * 提交时间变更请求变更信息
   *
   */
  checkSubmit = async value => {
    const { datePicker, agreement } = value
    // const start_time = `${getDateFormat(datePicker, 'YYYY-MM-DD HH:mm')}`
    const start_time = dayjs(datePicker).format('YYYY-MM-DD HH:mm')
    // 判断agreement，当为true时，继续；否则，弹框展示协议内容
    if (!agreement) {
      this.agreementVisible = true
      return false
    }

    if (
      this.id &&
      dayjs(start_time).valueOf() !== dayjs(this.start_time).valueOf()
    ) {
      const { success, data } = await Api.saveStartTimeDifference({
        id: this.id,
        newStartTime: start_time
      })
      if (success && +data.differencePrice && data.symbol != '=') {
        Modal.confirm({
          title: '修改直播时间提示',
          content: `修改本场直播开始时间，直播推广费用将${
            data.symbol == '>' ? '增加' : '减少'
          }
            ${data.differencePrice}元，确定提交修改么？`,
          onOk: this.submitForm(value)
        })
        return
      }
    }
    this.submitForm(value)()
  }

  //获取banner颜色
  @observable bannerColor
  @action
  getBannerColor = async ({ name, value }) => {
    let url = value
    if (!url) {
      this.bannerColor = undefined
      return
    }
    if (url.includes('?')) {
      url = url + '&imageView2/2/h/160%7CimageAve'
    } else {
      url = url + '?imageView2/2/h/160%7CimageAve'
    }
    const bannerColor = await fetch(url)
      .then(response => response.json())
      .then(res => res.RGB)
    runInAction(() => {
      this.bannerColor = bannerColor
    })
  }

  /**
   * 提交提报单信息
   * @param {Object} value 表单双向绑定信息
   */
  submitForm = value => async () => {
    const {
      datePicker,
      timePicker,
      appointment_content,
      other_gift_content,
      gift_of_attention,
      fromType,
      ...rest
    } = value
    const {
      id,
      watching_focus,
      image_path,
      vertical_image_path,
      videoInfo,
      verticalVideoInfo,
      //packageList,
      caseList
    } = this

    const recommends = [
      // {
      //   type: 4,
      //   extend: packageList
      //     .filter(p => p.checked)
      //     .map(p => ({ id: p.id, activity_price: p.activity_price }))
      // },
      {
        type: 7,
        ids: caseList
          .filter(p => p.checked)
          .map(p => p.id)
          .join(',')
      }
    ]
    const _rest =
      +fromType === 1
        ? { ...rest }
        : { ...rest, liveType: undefined, popTime: undefined }

    const param = {
      mark:
        property_id == 6 && value.fromType == 1 && value.liveType == 1
          ? '旅拍'
          : name,
      id,
      bannerColor: this.bannerColor,
      startTime: dayjs(datePicker).format('YYYY-MM-DD HH:mm'), //getDateFormat(datePicker, 'YYYY-MM-DD HH:mm'),
      imagePath: image_path,
      vertical_image_path,
      videoPath: videoInfo.origin_path,
      persistent_id: videoInfo.persistent_id,
      verticalVideoPath: verticalVideoInfo.vertical_origin_path,
      vertical_persistent_id: verticalVideoInfo.vertical_persistent_id,
      recommends,
      watchingFocus: watching_focus,
      preheats: [
        {
          type: 1,
          content: {
            text: appointment_content
          }
        },
        {
          type: 2,
          content: {
            text: other_gift_content
          }
        },
        {
          type: 5,
          content: {
            text: gift_of_attention
          }
        }
      ],
      fromType,
      ..._rest
    }

    if (!this.checkSubmitForm(param)) {
      return false
    }
    const url = this.id ? 'editLiveChannel' : 'addLiveChannel'
    const _param = this.id
      ? {
          ...param,
          fromType: undefined,
          liveType: undefined,
          popTime: undefined
        }
      : { ...param }
    const { success, RetCode } = await Api[url](_param)
    if (RetCode == 1000) {
      investModal()
      return
    }
    if (!success) {
      return
    }
    if (this.is_live_recommend && this.betterCases.length > 0) {
      this.triggerBetterModal()
    } else {
      setTimeout(() => {
        // hashHistory.push(`${LIVE_MANAGE_PATH}/liveShowGuide`) //返回帮助页
        hashHistory.push(`${LIVE_MANAGE_PATH}`) //返回直播管理页
      }, 1000)
    }

    return message.success('操作成功')
  }

  /**
   * 检查数据合法性
   * @param {Object} param 提报单信息
   * @return {Boolean} boolean 是否通过检测
   */
  @action
  checkSubmitForm = param => {
    const {
      imagePath,
      recommends,
      startTime,
      watchingFocus,
      title,
      vertical_image_path
    } = param
    if (!title) {
      message.warn('请填写标题')
      return false
    }
    if (!imagePath || !vertical_image_path) {
      message.warn('请设置封面图')
      return false
    }
    if (!dayjs().isBefore(dayjs(startTime), 'seconds')) {
      message.warn('请选择未来时间')
      return false
    }
    // if (recommends[0].extend.length < 1) {
    //   message.warn('请设置关联套餐')
    //   return false
    // }
    if (
      !isHotelMerchant() &&
      !isWeddingDressProperty() &&
      recommends[0].ids.length < 1
    ) {
      message.warn('请设置关联案例')
      return false
    }
    if (watchingFocus.length < 1) {
      message.warn('请设置直播看点')
      return false
    }
    return true
  }
}
